// context/PackagesModalContext.jsx

import React, { createContext, useState, useContext, useCallback } from "react";

const PackagesModalContext = createContext();

export const usePackagesModal = () => useContext(PackagesModalContext);

export const PackagesModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({
    onSelect: null,
    onClose: null,
  });

  const showPackages = useCallback((options = {}) => {
    setConfig({
      onSelect: options.onSelect || null,
      onClose: options.onClose || null,
    });
    setIsOpen(true);
  }, []);

  const hidePackages = useCallback(() => {
    setIsOpen(false);
    if (config.onClose) {
      config.onClose();
    }
  }, [config.onClose]);

  const handleSelectPackage = useCallback(
    (pkg) => {
      if (config.onSelect) {
        config.onSelect(pkg);
      }
      hidePackages();
    },
    [config.onSelect, hidePackages],
  );

  return (
    <PackagesModalContext.Provider
      value={{
        isOpen,
        showPackages,
        hidePackages,
        handleSelectPackage,
      }}
    >
      {children}
    </PackagesModalContext.Provider>
  );
};
